import { VueModule } from '@Foundation/utilities';
import DataCuesList from './code/Scripts/components/DataCuesList.vue';
import DataCuesChart from './code/Scripts/components/DataCuesChart.vue';
import DataCuesGauge from './code/Scripts/components/DataCuesGauge.vue';

export default VueModule({
  components: {
    DataCuesList,
    DataCuesChart,
    DataCuesGauge
  }
});
